import { render, staticRenderFns } from "./ChevronDoubleRightIcon.vue?vue&type=template&id=190bd25c&scoped=true"
import script from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190bd25c",
  null
  
)

export default component.exports